import React from 'react';
import { Row, Col } from 'antd';

import { Field } from './Field';
import { Title } from '@/components/Typography';
import { InformationsResult } from '@/core/domain/owas-report';
import * as S from './styles';

interface InformationsProps {
	data: InformationsResult;
}

export function Informations({ data }: Readonly<InformationsProps>): JSX.Element {
	return (
		<Row>
			<Col span={24}>
				<Row gutter={[0, 10]}>
					<Col span={24}>
						<Title level={2}>Informations</Title>
					</Col>
					<Col span={24}>
						<S.Content justify="space-between">
							<Col span={12}>
								<Row gutter={[0, 8]}>
									<Field label="Company" value={data.organization_name} />
									<Field label="Industrial site" value={data.company_name} />
									<Field label="Sector" value={data.sector_name} />
									<Field label="Line" value={data.line_name} />
									<Field label="Workstation" value={data.workstation_name} />
									<Field label="Activity" value={data.activity_name} />
								</Row>
							</Col>
							<Col span={1}>
								<S.CustomDivider type="vertical" />
							</Col>
							<Col xs={10} xxl={{ span: 10, offset: 1 }}>
								<Row gutter={[0, 8]}>
									<Field label="Report name" value={data.report_name} />
									<Field label="File" value={data.file_name} />
									<Field label="Collection date" value={data.collection_date} />
									<Field label="Assessment date" value={data.analysis_date} />
									<Field label="Evaluator" value={data.evaluator_name} />
								</Row>
							</Col>
						</S.Content>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
